import { Dialog } from '@material-ui/core';

import { Branding } from '../SignUp/CreateAccountForm';
import { TransitionScreen } from '../TransitionScreen';

/**
 * Landing page after clicking email verification link.
 *
 * This is a simple confirmation page that tells the user their email
 * has been verified and they can close this tab. The original signup
 * tab should still be open - they can click "I've verified my email"
 * there to continue.
 */
export const EmailVerifiedPage = () => {
  return (
    <Dialog open fullScreen>
      <Branding />
      <TransitionScreen
        title="Email verified!"
        description="Your email has been verified. You can close this tab and return to the signup window."
      />
    </Dialog>
  );
};
